import React, { useContext, useEffect, useState, useRef } from 'react';
import { StoreContext } from '../StoreHandler/StoreContext';
import { ProductContactForm } from '../ContactForm/ContactForm';
import { styled } from 'linaria/react';
import { ReactComponent as Up } from '../../svg/CarretUp.svg';
import { ReactComponent as Down } from '../../svg/CarretDown.svg';
import FormStoreMap from '../StoreLocator/FormStoreMap';
import { theme } from '../Theme';

const ContantStoreWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  .form-info {
    display: flex;
    gap: 32px;

    .information {
      margin-top: 16px;
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 160%;

      table {
        height: auto !important;
      }
      strong {
        font-weight: 600;
      }
    }

    ${theme.below.lg} {
      flex-direction: column-reverse;
    }
  }

  p {
    color: #000;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 160% !important; /* 22.4px */
    margin: 0;
    margin-bottom: 10px;
  }

  .map-container {
    height: 266px;
  }

  .storemap-wrapper {
    padding: 0;
    margin-top: 20px;

    h2 {
      color: #000;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 160%; /* 22.4px */
    }
  }
`;

const StoreSelectWrapper = styled('div')`
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  button {
    width: 100%;
    height: 40px;
    border: none;
    background: #f7f7f7;
    color: #000;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%; /* 19.2px */
    display: flex;
    align-items: center;
    padding: 0 16px;
    cursor: pointer;

    svg {
      height: 10px;
      width: 10px;
    }

    &.dropdown {
      border: 1px solid #d2d2d2;
    }
  }
`;

const IndicatorIcon = styled('span')`
  margin-left: auto;
  font-size: 1.25rem;
`;

const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon>{isOpen ? <Up /> : <Down />}</IndicatorIcon>
);

const StoreSelect = ({ stores, activeStore, setActiveStore }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <StoreSelectWrapper>
      <button className="dropdown" onClick={toggleDropdown}>
        {activeStore === 'Välj butik' ? activeStore : activeStore?.name}
        <AccordionIndicator isOpen={isOpen} />
      </button>
      {isOpen && (
        <ul>
          {stores?.map((store) => {
            return (
              <li>
                <button
                  onClick={() => [setActiveStore(store), setIsOpen(!isOpen)]}
                >
                  {store?.name}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </StoreSelectWrapper>
  );
};

const StoreProductStatus = ({ storeName, product, storeList }) => {
  let email = false;

  if (storeList) {
    const currentStore = storeList.find((store) => {
      return (
        storeName?.name?.trim()?.toLowerCase() ===
        store?.name?.trim()?.toLowerCase()
      );
    });
    email = currentStore?.storeInfo?.email;
  }

  return (
    <>
      <ProductContactForm isModal productName={product.name} email={email} />
    </>
  );
};

export const ContactStore = ({ product }) => {
  const { storeList, selectedStore } = useContext(StoreContext);
  const stores = storeList;

  const [activeStore, setActiveStore] = useState(selectedStore ?? 'Välj butik');
  const long = activeStore?.extra?.coordinates?.longitude;
  const lat = activeStore?.extra?.coordinates?.latitude;
  const openHours = activeStore?.storeInfo?.['open-hours'];
  const formattedOpenHours = openHours?.replace(/\n/g, '<br>');
  const storeInfoContact = {
    phone: activeStore.storeInfo?.phone?.replace('+46', '0'), // Ändra +46 till 0
    email: activeStore?.storeInfo?.email,
  };

  useEffect(() => {
    if (selectedStore) {
      setActiveStore(selectedStore);
    } else {
      setActiveStore('Välj butik');
    }
  }, [selectedStore]);

  const storeMapProps = {
    activeStore,
    long,
    lat,
  };
  return (
    <ContantStoreWrapper>
      <p>
        Vill du hitta till närmsta butik? <br />
        Välj din butik i listan och kontakta via formuläret, e-post eller
        telefon. Välkommen!
      </p>

      <StoreSelect
        stores={stores}
        activeStore={activeStore}
        setActiveStore={setActiveStore}
      />

      {activeStore !== 'Välj butik' && (
        <>
          <FormStoreMap {...storeMapProps} />
          <div className="form-info">
            <StoreProductStatus
              storeName={activeStore}
              product={product}
              storeList={storeList}
            />
            <div className="information">
              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: formattedOpenHours,
                  }}
                />
                <br />
                <div>
                  <strong>Kontakt</strong>
                  <p style={{ marginBottom: '0' }}>
                    E-postadress:
                    <a
                      href={`mailto:${storeInfoContact.email}`}
                      dangerouslySetInnerHTML={{
                        __html: storeInfoContact?.email,
                      }}
                      style={{ marginLeft: '5px', color: '#000' }}
                    />
                  </p>
                  <p>
                    Telefonnummer:
                    <span
                      dangerouslySetInnerHTML={{
                        __html: storeInfoContact?.phone,
                      }}
                      style={{ marginLeft: '5px' }}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </ContantStoreWrapper>
  );
};
